import { priceFormatter } from '@2wunder/klarx-tool'
import { Col } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import KTable from 'app/components/Modules/Table/KTable'
import KSingleCollapse from 'app/components/UI-Elements/DataDisplay/KSingleCollapse'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React from 'react'

import LineItemTotalCost from './Total'

const LineItemMachinePrices: React.FC<CollectionProps<ILineItem>> = ({ collection = [] }) => {
  const { tRecordType, tAttribute } = ToolBox.useString()

  const sortedCollection = collection
    .slice()
    .sort((a: ILineItem, b: ILineItem) => a.line_item_id - b.line_item_id)

  const TotalCosts = () => (
    <LineItemTotalCost
      collection={collection}
      props={{
        memberProps: { name: tRecordType(RecordType.line_item, 'product_costs_total') }
      }}
    />
  )

  const QuantityWithUnit = (member: ILineItem) => {
    const unitName = member.unit?.name
    return (
      <span className={!member.lineItemId ? 'text-bold' : ''}>
        {member.quantity} {unitName}
      </span>
    )
  }

  const discountedUnitPrice = (member: ILineItem) => {
    return (
      <span className={!member.lineItemId ? 'text-bold' : ''}>
        {member.discountedUnitPrice > 0
          ? priceFormatter(member.discountedUnitPrice)
          : tRecordType(RecordType.subItem, 'inclusive')}
      </span>
    )
  }

  return (
    <KSingleCollapse
      className={'checkout'}
      headerCollapsed={
        <h6 className="text-black mb-0">
          <TotalCosts />
        </h6>
      }
      header={<h6 className="text-black mb-0">{tRecordType(RecordType.line_item, 'products')}</h6>}>
      <>
        <KTable
          size={'small'}
          recordType={RecordType.lineItem}
          dataSource={sortedCollection}
          className={'checkout-table'}
          columns={[
            {
              title: <strong> {tRecordType(RecordType.line_item, 'name')} </strong>,
              dataIndex: 'name',
              render: (value, record) => (!record.lineItemId ? <strong>{value}</strong> : value)
            },
            {
              title: (
                <strong>
                  {tAttribute({ recordType: RecordType.lineItem, attribute: 'unit' })}
                </strong>
              ),
              dataIndex: 'quantity',
              render: (_value, record) => QuantityWithUnit(record)
            },
            {
              title: (
                <strong>
                  {' '}
                  {tAttribute({ recordType: RecordType.lineItem, attribute: 'price' })}
                </strong>
              ),
              dataIndex: 'discountedUnitPrice',
              render: (_value, record) => discountedUnitPrice(record)
            }
          ]}
          scroll={{ x: 'max-content' }}
        />

        <Col span={24} className={'pt-3'}>
          <strong>
            <TotalCosts />
          </strong>
        </Col>
      </>
    </KSingleCollapse>
  )
}

export default LineItemMachinePrices
